import { create } from 'zustand'

type FormSaveState = {
    hasChanges: boolean
    skipPromptOnce: boolean
    setFormChanges: (hasChange: boolean) => void
    resetChanges: () => void
    skipNextPrompt: () => void
    clearPromptSkip: () => void
}

export const useFormSaveStore = create<FormSaveState>((set) => ({
    hasChanges: false,
    skipPromptOnce: false,

    setFormChanges: (hasChange) => set({ hasChanges: hasChange }),
    resetChanges: () => set({ hasChanges: false, skipPromptOnce: false }),
    skipNextPrompt: () => set({ skipPromptOnce: true }),
    clearPromptSkip: () => set({ skipPromptOnce: false })
}))
